import { Card, CardContent } from '@/components/ui/card';

const StatusIndicator = ({ kiosk }) => {
  const statusColor = kiosk?.status === 'active' ? 'bg-green-500' : 'bg-red-500';
  
  return (
    <div className="fixed bottom-8 right-8">
      <Card className="bg-white text-foreground">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className={`w-4 h-4 rounded-full ${statusColor} animate-pulse`} />
            <span className="font-medium capitalize">
              {kiosk?.status || 'Unknown'}
            </span>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default StatusIndicator;
